import { Stack, IconButton, Typography, Box } from "@mui/material";
import XIcon from "@mui/icons-material/X"; // Replace with the correct icon import if needed
import { darkColors } from "../../../theme/colors";
import { assetIcons } from "../../../constants/assets";
import { socialRedirectUrls } from "../../../constants/urls";
import FacebookIcon from "@mui/icons-material/Facebook";

const MobileSocialAccountBar = ({
  text,
  onIconClick,
  onLogoutClick,
  onSettingsClick,
  isMobile,
}) => {
  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      spacing={2}
      sx={{ mt: isMobile ? 1 : 8, alignItems: "center" }}
    >
      {/* Icons on the left */}
      <Stack
        direction="row"
        pt={isMobile ? 5 : 0}
        order={isMobile ? 1 : 0}
        spacing={1.5}
      >
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => onIconClick(socialRedirectUrls.discord)}
        >
          <img src={assetIcons.discord} alt="discord" />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => onIconClick(socialRedirectUrls.facebook)}
        >
          <FacebookIcon />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => onIconClick(socialRedirectUrls.twitter)}
        >
          <XIcon />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => onIconClick(socialRedirectUrls.tiktok)}
        >
          <img src={assetIcons.tiktok} alt="tiktok" width={30} height={30} />
        </IconButton>
      </Stack>

      {/* Spacer to push the text to the right */}
      <Box sx={{ flex: 1 }} />

      <IconButton
        sx={{
          "&:hover": {
            backgroundColor: "transparent", // Removes hover background
          },
          padding: 0, // Optional: removes padding around the Avatar if desired
        }}
        disableRipple
        color="inherit"
      >
        <Box
          onClick={onSettingsClick}
          ml={1.5}
          component={"img"}
          src={assetIcons.settings}
          alt="settings"
        ></Box>
        <Box
          onClick={onLogoutClick}
          ml={1.5}
          component={"img"}
          src={assetIcons.logout}
          alt="logout"
        ></Box>
      </IconButton>
    </Stack>
  );
};

export default MobileSocialAccountBar;
